import { render, staticRenderFns } from "./OfficialHolidayEdit.vue?vue&type=template&id=b5025b10&scoped=true&"
import script from "./OfficialHolidayEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidayEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5025b10",
  null
  
)

export default component.exports